import PropTypes from "prop-types";
import Toggle from "@shared/v2/Toggle";
import { LockSolidV6, TrashCanSolidV6 } from "@shared/v2/Icomoon";
import TextLink from "@shared/v2/TextLink";
import IconButton from "@shared/v2/IconButton";
import Tooltip from "@shared/v2/Tooltip";
import { TD, TR } from "../../Reports/components/BusinessDashboard/Table/Table";

const Source = ({
  onToggle,
  onDelete,
  source,
  source: { id, hidden, name, isBrivityDefault, isDefault, appliedTo, appliedToCount },
}) => {
  const hasPeopleApplied = appliedToCount > 0;
  const deleteButton = (
    <IconButton
      schema="misc-trash"
      disabled={hasPeopleApplied}
      // A disabled button dispatches no pointer events, so the tooltip's wrapper
      // would never see the hover. Letting the pointer through to that wrapper is
      // what keeps the disabled explanation reachable.
      className={hasPeopleApplied ? "tw-pointer-events-none" : ""}
      onClick={() => onDelete(source)}
      aria-label={`Delete ${name}`}
    >
      <TrashCanSolidV6 size="l" />
    </IconButton>
  );

  return (
    <TR>
      <TD>{name}</TD>
      <TD>
        <TextLink href={`/people/leads?leads_filter[selected_sources][]=${id}`} target="_blank">
          {appliedTo}
        </TextLink>
      </TD>
      <TD className="tw-text-center">
        {isBrivityDefault ? (
          <LockSolidV6 className="tw-text-gray-50" size="xl" />
        ) : (
          <Toggle
            checked={!hidden}
            onChange={() => onToggle(source)}
            labelClassName="tw-mb-0 !tw-inline-flex"
          />
        )}
      </TD>
      <TD>
        {!isDefault &&
          (hasPeopleApplied ? (
            <Tooltip
              placement="left"
              innerClassName="tw-max-w-[351px]"
              content="Can not delete a source currently applied to people"
              trigger={deleteButton}
            />
          ) : (
            deleteButton
          ))}
      </TD>
    </TR>
  );
};

Source.propTypes = {
  onToggle: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  source: PropTypes.shape({
    id: PropTypes.number.isRequired,
    hidden: PropTypes.bool,
    name: PropTypes.string.isRequired,
    isBrivityDefault: PropTypes.bool,
    isDefault: PropTypes.bool,
    appliedTo: PropTypes.string,
    appliedToCount: PropTypes.number,
  }).isRequired,
};

export default Source;
